const initialState = {
  dataTableList: [],
  dataCreatives: [],
  dataCompanies: [],
  accountType: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ACCOUNT_TABLE":
      return {
        ...state,
        dataTableList: action.payload,
      };
    case "FETCH_CREATIVES":
      return {
        ...state,
        dataCreatives: action.payload,
      };
    case "FETCH_COMPANIES":
      return {
        ...state,
        dataCompanies: action.payload,
      };
    case "SET_ACCOUNT_TYPE":
      return {
        ...state,
        accountType: action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
